export const stationeryNumbers = [
  "ANCDOC",
  "ALTDOC",
  "CABDOC",
  "TALDOC",
  "TANDOC",
];

export const pxPerInch = 96;

// every code in stationeryNumbers is stored in pixels at 96 dpi and edited in inches
export const inchesToPaperValue = (inches: number | string) =>
  Math.round(Number(inches) * pxPerInch);

export const paperValueToInches = (value: number | string) =>
  Math.round((Number(value) / pxPerInch) * 100) / 100;

export const docExclude = [
  "INC",
  "PCO",
  "FIS",
  "REL",
  "ABR",
  "NAB",
  "ADJ",
  "POS",
  "GPS",
  "QR",
];

export const branchCodes = [
  "NOMSUC",
  "NBRSUC",
  "RSOSUC",
  "RUCSUC",
  "DIRSUC",
  "TELSUC",
  "WHTSUC",
  "WEBSUC",
  "EMASUC",
  "HO1SUC",
  "HO2SUC",
  "HO3SUC",
];

export const numbersInclude = ["TOT", "PRE", "NET", "IMP", "PCO", "SAL", "ABO"];

export const newDates = ["DATEONLY", "HOUR"];

export const staDef = [
  "DATEONLY",
  "HOUR",
  "CURRPAGE",
  "QTYPAGES",
  "FORMNUMBER",
];

export const linesExclude = ["COD", "SER", "PCO", "HUE", "UNI"];

export const personExclude = ["COD", "CNT", "MLO", "SYNC"];
